import { useCallback, useRef } from "react";
import { useMutation } from "@apollo/client";
import { SAVE_ONBOARDING_STATE_MUTATION } from "@/graphql/mutations/onboarding";

// Debounced autosave for onboarding state fragments
// Reason: Reduce server load while ensuring user progress persists
export function useOnboardingAutosave(delayMs = 500) {
  const [saveState] = useMutation(SAVE_ONBOARDING_STATE_MUTATION);
  const timer = useRef<number | null>(null);

  const scheduleSave = useCallback(
    (patch: Record<string, any>, merge = true) => {
      if (timer.current) {
        window.clearTimeout(timer.current);
        timer.current = null;
      }
      timer.current = window.setTimeout(() => {
        saveState({ variables: { state: patch, merge } }).catch(() => {
          // Silent failure: autosave should be non-intrusive
        });
      }, delayMs);
    },
    [delayMs, saveState]
  );

  return { scheduleSave };
}
